module.exports = __webpack_public_path__ + "img/m1.b6687008.png";